import isEqual from 'lodash/isEqual'
import { IntlFormatters } from 'react-intl'
import {
  createKeysAndColumnNameArray,
  DenseTableRowProps,
  CellProps,
  getNewTableRows,
  getOldTableRows
} from '../../../../../components'
import { BASIC_DATE_FORMAT } from '../../../../../utils'
import { MaybeBoolean } from '../../../../../utils/types/types'
import {
  EmploymentData,
  EmploymentObligationData,
  EmploymentRowProps,
  Profession
} from '../types'

export const professionKeysAndColumns: CellProps<Profession>[] =
  createKeysAndColumnNameArray('pages.ownInfoPage.employment.profession.', [
    {
      key: 'profession',
      translationIdPostfix: 'label'
    },
    {
      key: 'professionTitle',
      translationIdPostfix: 'title'
    },
    {
      key: 'field',
      translationIdPostfix: 'field'
    }
  ])

export const createProfessionArray = (
  professionInfo: Profession
): DenseTableRowProps<Profession>[] => {
  const profession: Profession = {
    profession: professionInfo.profession,
    professionTitle: professionInfo.professionTitle,
    field: professionInfo.field
  }
  return [profession]
}

export const obligationKeysAndColumns: CellProps<EmploymentObligationData>[] =
  createKeysAndColumnNameArray('pages.ownInfoPage.employment.obligations.', [
    {
      key: 'maksutapa',
      translationIdPostfix: 'paymentMethod.label'
    },
    {
      key: 'viitelaji',
      translationIdPostfix: 'referenceType'
    },
    {
      key: 'maksujaksonPituus',
      translationIdPostfix: 'paymentPeriodLength'
    },
    {
      key: 'aloituspvm',
      translationIdPostfix: 'startDate',
      dateFormat: BASIC_DATE_FORMAT
    },
    {
      key: 'lopetuspvm',
      translationIdPostfix: 'endDate',
      dateFormat: BASIC_DATE_FORMAT
    }
  ])

const getEmploymentTypePostFix = (fullTime: MaybeBoolean) => {
  return fullTime ? 'fullTime' : 'partTime'
}

export const getEmploymentTypeText = (
  fullTime: MaybeBoolean,
  formatMessage: IntlFormatters['formatMessage']
) => {
  return formatMessage({
    id:
      'pages.ownInfoPage.employment.employments.type.types.' +
      getEmploymentTypePostFix(fullTime)
  })
}

const getPaymentMethodPostFix = (settlement: MaybeBoolean) => {
  return settlement ? 'settlement' : 'selfPayment'
}

export const getPaymentMethodText = (
  settlement: MaybeBoolean,
  formatMessage: IntlFormatters['formatMessage']
) => {
  return formatMessage({
    id:
      'pages.ownInfoPage.employment.employments.paymentMethod.type.' +
      getPaymentMethodPostFix(settlement)
  })
}

export const getNewAndChangedEmploymentRows = (
  employmentRows: EmploymentData[],
  initialEmploymentRows: EmploymentData[]
) => {
  const oldRows = getOldTableRows<EmploymentRowProps>(employmentRows)

  const changedRows = oldRows.filter(
    (oldRow, index) => !isEqual(oldRow, initialEmploymentRows[index])
  )

  const newRows = getNewTableRows<EmploymentRowProps>(employmentRows)

  return [...changedRows, ...newRows]
}
